import css from "../index.module.css";

export default function About() {
  return (
    <div className={css.col1}>
        <div className={css.accountInfo}>
            <b className={css.headAcc}>О нас</b>

            <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
                marginTop: 20,
            }}
            >
            <div
                style={{
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 12,
                padding: 16,
                }}
            >
                <div
                style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}
                >
                Рыбный мир
                </div>
                <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "140px 1fr",
                    gap: 8,
                }}
                >
                <span style={{ color: "#6b7280" }}>ИНН</span>
                <span>550313913879</span>
                <span style={{ color: "#6b7280" }}>ОГРНИП</span>
                <span>325554300069246</span>
                <span style={{ color: "#6b7280" }}>Адрес</span>
                <span>ХМАО-Югра, г.Сургут, ул.Сосновая д.3</span>
                <span style={{ color: "#6b7280" }}>Телефон</span>
                <a
                    href="tel:+79227982617"
                    style={{ color: "#111827", textDecoration: "none" }}
                    onClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'tel:+79227982617';
                    }}
                >
                    +7 922 798-26-17
                </a>
                <span style={{ color: "#6b7280" }}>Карта</span>
                <a
                    href="https://2gis.ru/surgut/geo/5489397701025000/73.483439,61.241362"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#2563eb" }}
                >
                    Открыть в 2ГИС
                </a>
                </div>
            </div>

            <div
                style={{
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 12,
                overflow: "hidden",
                }}
            >
                <iframe
                id="map_348399838"
                width="100%"
                height="300px"
                src="https://makemap.2gis.ru/widget?data=eJw1jk1rwzAMhv-Ldg3FjvPhBnoYHRtlZZReBhs9hETrPJwoOCq0C_nvU5JOF4HeDz0DUKgxYP2C1CAHhz0UnwPwrUMo4BlLvgSECLpAHQae9QEq8hREf1Cx1V-x6OzYTwn1-nR06-1V7c20093btlL7n-P5cbMRW419FVzHjloxy-F319Z4hUKr_xkjOC8wt-nVneRArmXxVyTAri15Bs3NKrEmzdMo06s40cbqk-RdDYXJkvEUQVN2B-rd8nAAXzIUd2-WJsqY1OosAj_JS1tmYqvitaxc8IgagculVMDJ-_dvRP8xXzlccPwD3xZhLg"
                sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"
                ></iframe>
            </div>
            </div>
        </div>
    </div>
  );
}
